































































































































import Vue from "vue";
import HelpPanel from "@/features/helpCenter/components/helpPanel.vue";
import PageTitle from "@/commons/components/PageTitle.vue";

export default Vue.extend({
  components: {
    "help-panel": HelpPanel,
    "page-title": PageTitle,
  },
  data() {
    return {
      instructionUrl1:
        "https://esa-pages.io/p/sharing/14553/posts/1528/5e26c463b74590a7dae5.html" as string,
      instructionUrl2:
        "https://esa-pages.io/p/sharing/14553/posts/1529/9d4751d531c3f456e0f0.html" as string,
      bidderNameSyntaxUrl:
        "https://esa-pages.io/p/sharing/14553/posts/1544/8b8768d0a5b876cefa51.html" as string,
      pubMaticSortingLogicUrl:
        "https://community.pubmatic.com/pages/viewpage.action?pageId=20520308" as string,
    };
  },
});
